import { Component, Input } from '@angular/core';
import { CompanyLogoConfiguration } from 'src/app/models/auxiliary/company-logo-configuration';
import { CommonDataService } from 'src/app/sections/common/services/common-data.service';

@Component({
  selector: 'app-prescriptions-list-report',
  templateUrl: './prescriptions-list-report.component.html',
  styleUrls: ['./prescriptions-list-report.component.scss']
})
export class PrescriptionsListReportComponent {

  @Input() reportId: string;
  @Input() printPrescriptionList: [];
  companyLogo: CompanyLogoConfiguration = null;

  date= new Date();

  constructor(public commonDataService: CommonDataService) {
    this.companyLogo = new CompanyLogoConfiguration();
  }
  ngOnInit() {
    this.commonDataService.getCompanyLogo().subscribe((labConfiguration: CompanyLogoConfiguration) => {
      this.companyLogo = labConfiguration;
    });
  }

}
